// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrap-templateid-report {
    margin: 0 40px;
  }

  .template-date-filter-form-summary {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 25px 20px;
    margin: 20px auto; 
    gap: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  } 
  
  .templateid-date-field {
    display: flex;
    flex-direction: column;
    width: 100%
  }
  
  .templateid-date-field label {
    font-weight: bold;
    margin-bottom: 8px;
    text-align: left;
  }
  
  .templateid-date-field input {
    padding: 10px 5px;
    font-size: 16px;
    border: 1px solid #f2f2f2;
  }

  .templateid-input-actions {
    display: flex;
    gap: 20px;
    align-items: center;
    padding: 15px 0 0;
    width: 30%;
  }

  .templateid-form-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 15px 0 0;
  }
  
  .templateid-form-actions .btn {
    padding: 8px 16px;
    font-size: 16px;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .templateid-input-actions .submit-btn {
    background-color: #44a67e;
    border-color: #44a67e;
    margin-top: 20px;
    padding: 12px 15px;
  }
  
  .templateid-form-actions .submit-btn:hover {
    background-color: #44a67e;
    border-color: #44a67e;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }
  
  .templateid-form-actions .download-btn {
    background: #373435;
    color: #ffcc29;
    margin-top: 20px;
  }
  
  .templateid-form-actions .download-btn:hover {
    background: #373435;
    color: #ffcc29;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
  }

  .templateid-search-filter {
    margin: 20px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    align-items: center;
    gap: 20px;
  }
  
  .templateid-search-filter input {
    width: 250px;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
  }

  .templateid-table-container {
    width: 100%;
    overflow-x: auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }

  .templateid-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .templateid-table th,
  .templateid-table td {
    padding: 12px 15px;
    border: 1px solid #ddd;
    font-size: 14px;
  }
  
  .templateid-table th {
    background-color: #f4f4f4;
    color: #373435;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
  }
  
  .templateid-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .templateid-table tbody tr:hover {
    background-color:  rgba(255, 204, 41, 0.2);
  }
  
  .templateid-table td {
    color: #373435;
  }
  
  .templateid-table tbody tr:last-child td {
    border-bottom: 2px solid #ffcc29;
  }

  /* Expand Button */
.templateid-expand-btn {
    background: #373435;
    color: #ffcc29;
    border: none;
    padding: 5px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 16px;
  }
  
  .templateid-expand-btn:hover {
    background: #ffcc29;
    color: #373435;
  }

  /* Expanded Row */
.templateid-expanded-row {
    background-color: #eef7ff;
  }
  
.templateid-expanded-content {
    padding: 10px;
  }

  @media (max-width: 700px) {
    .template-date-filter-form-summary {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;
    }
  
    .templateid-date-field input {
      max-width: 100%;
    }
  
    .templateid-form-actions {
      flex-direction: column;
      width: 100%;
    }
  
    .templateid-form-actions .btn {
      width: 100%;
      text-align: center;
    }
  }
  
  @media screen and (max-width: 768px) {
    .template-date-filter-form-summary {
        flex-direction: column;
        align-items: flex-start;
    }
  
    .templateid-date-field {
        width: 100%;
        align-items: center;
    }
  
    .templateid-form-actions {
        flex-direction: column;
        width: 100%;
    }
  
    .templateid-form-actions .btn {
        width: 100%;
    }
  
    .templateid-table-container {
      overflow-x: auto;
    }
  }  

  @media screen and (max-width: 1050px) {
    .under-1000px {
      display: none;
    }  
  }
  
  @media screen and (min-width: 1051px) {
    .toggle-button-expansion {
      display: none;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/TemplateIdReport/TemplateIdReport.css"],"names":[],"mappings":"AAAA;IACI,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB;EACF;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,qFAAqF;EACvF;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,qFAAqF;EACvF;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gCAAgC;EAClC;;EAEA,kBAAkB;AACpB;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA,iBAAiB;AACnB;IACI,yBAAyB;EAC3B;;AAEF;IACI,aAAa;EACf;;EAEA;IACE;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,WAAW;IACb;;IAEA;MACE,WAAW;MACX,kBAAkB;IACpB;EACF;;EAEA;IACE;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,aAAa;IACf;EACF","sourcesContent":[".wrap-templateid-report {\r\n    margin: 0 40px;\r\n  }\r\n\r\n  .template-date-filter-form-summary {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 25px 20px;\r\n    margin: 20px auto; \r\n    gap: 20px;\r\n    background-color: #fff;\r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  } \r\n  \r\n  .templateid-date-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%\r\n  }\r\n  \r\n  .templateid-date-field label {\r\n    font-weight: bold;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n  }\r\n  \r\n  .templateid-date-field input {\r\n    padding: 10px 5px;\r\n    font-size: 16px;\r\n    border: 1px solid #f2f2f2;\r\n  }\r\n\r\n  .templateid-input-actions {\r\n    display: flex;\r\n    gap: 20px;\r\n    align-items: center;\r\n    padding: 15px 0 0;\r\n    width: 30%;\r\n  }\r\n\r\n  .templateid-form-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n    padding: 15px 0 0;\r\n  }\r\n  \r\n  .templateid-form-actions .btn {\r\n    padding: 8px 16px;\r\n    font-size: 16px;\r\n    color: #fff;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .templateid-input-actions .submit-btn {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n    margin-top: 20px;\r\n    padding: 12px 15px;\r\n  }\r\n  \r\n  .templateid-form-actions .submit-btn:hover {\r\n    background-color: #44a67e;\r\n    border-color: #44a67e;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n  \r\n  .templateid-form-actions .download-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .templateid-form-actions .download-btn:hover {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\r\n  }\r\n\r\n  .templateid-search-filter {\r\n    margin: 20px auto;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: end;\r\n    align-items: center;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .templateid-search-filter input {\r\n    width: 250px;\r\n    padding: 12px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .templateid-table-container {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    margin-top: 20px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    background: #fff;\r\n  }\r\n\r\n  .templateid-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .templateid-table th,\r\n  .templateid-table td {\r\n    padding: 12px 15px;\r\n    border: 1px solid #ddd;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .templateid-table th {\r\n    background-color: #f4f4f4;\r\n    color: #373435;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .templateid-table tbody tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .templateid-table tbody tr:hover {\r\n    background-color:  rgba(255, 204, 41, 0.2);\r\n  }\r\n  \r\n  .templateid-table td {\r\n    color: #373435;\r\n  }\r\n  \r\n  .templateid-table tbody tr:last-child td {\r\n    border-bottom: 2px solid #ffcc29;\r\n  }\r\n\r\n  /* Expand Button */\r\n.templateid-expand-btn {\r\n    background: #373435;\r\n    color: #ffcc29;\r\n    border: none;\r\n    padding: 5px 10px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .templateid-expand-btn:hover {\r\n    background: #ffcc29;\r\n    color: #373435;\r\n  }\r\n\r\n  /* Expanded Row */\r\n.templateid-expanded-row {\r\n    background-color: #eef7ff;\r\n  }\r\n  \r\n.templateid-expanded-content {\r\n    padding: 10px;\r\n  }\r\n\r\n  @media (max-width: 700px) {\r\n    .template-date-filter-form-summary {\r\n      flex-direction: column;\r\n      align-items: flex-start;\r\n      gap: 15px;\r\n    }\r\n  \r\n    .templateid-date-field input {\r\n      max-width: 100%;\r\n    }\r\n  \r\n    .templateid-form-actions {\r\n      flex-direction: column;\r\n      width: 100%;\r\n    }\r\n  \r\n    .templateid-form-actions .btn {\r\n      width: 100%;\r\n      text-align: center;\r\n    }\r\n  }\r\n  \r\n  @media screen and (max-width: 768px) {\r\n    .template-date-filter-form-summary {\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n    }\r\n  \r\n    .templateid-date-field {\r\n        width: 100%;\r\n        align-items: center;\r\n    }\r\n  \r\n    .templateid-form-actions {\r\n        flex-direction: column;\r\n        width: 100%;\r\n    }\r\n  \r\n    .templateid-form-actions .btn {\r\n        width: 100%;\r\n    }\r\n  \r\n    .templateid-table-container {\r\n      overflow-x: auto;\r\n    }\r\n  }  \r\n\r\n  @media screen and (max-width: 1050px) {\r\n    .under-1000px {\r\n      display: none;\r\n    }  \r\n  }\r\n  \r\n  @media screen and (min-width: 1051px) {\r\n    .toggle-button-expansion {\r\n      display: none;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
